<template>
	<div>
		<table class="table" :class="{ correct: !isRunning }">
			<thead>
				<tr>
					<th scope="col"></th>
					<th scope="col" v-for="title in topHeaders" :key="title">{{ $t(title) }}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(_, row) in rows" :key="row"
					:class="{ highlight: isRunning && selectedValue == highlightValues[row] }">
					<th scope="row" class="col-1">{{ $t(leftHeaders[row]) }}</th>
					<td v-for="(_, col) in cols" :key="col" class="col-3">
						<div class="input-group" :class="{
							incorrect: answer[row * cols + col] == incorrect[row * cols + col],
							malformed: !isValidNumber(answer[row * cols + col])
						}">
							<input type="text" class="form-control" :disabled="!isRunning"
								v-model="answer[row * cols + col]">
							<span class="input-group-text">{{ $t(units[col]) }}</span>
							<div v-if="answer[row * cols + col] == incorrect[row * cols + col]" class="incorrect-bubble"
								style="z-index: 9;"></div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<!-- Verify button -->
		<p v-if="isRunning" class="verify-button">
			<b class="btn progress-bar-striped"
				:class="{ 'btn-primary': allowVerify, 'btn-secondary': !allowVerify, 'progress-bar-animated': allowVerify }"
				@click="onVerify" :disabled="!allowVerify">
				{{ $t('quiz_button_verify') }}
			</b>
		</p>
	</div>
</template>



<script>
import TaskBox from './TaskBox.vue';

export default {
	mixins: [TaskBox],
	data() {
		return {
			rows: 3,
			cols: 3,
			topHeaders: [
				"table_global_temperature",
				"table_co2_concentration",
				"table_ch4_concentration",
			],
			leftHeaders: [
				"table_without_greenhouse",
				"table_natural_greenhouse",
				"table_enhanced_greenhouse",
			],
			units: [
				"unit_celcius",
				"unit_ppm",
				"unit_ppm",
			],
			highlightValues: [
				"m3t2a_slider_state1",
				"m3t2a_slider_state2",
				"m3t2a_slider_state3",
			],

			answer: [
				'', '', '',
				'', '', '',
				'', '', '',
				// -18, 0, 0,
				// 14, 280, 0.73,
				// 15, 388, 1.84,
			],
			correct: [
				-18, 0, 0,
				14, 280, 0.73,
				15, 388, 1.84,
			],
			correctRange: [
				[-18, -18], [0, 0], [0, 0],
				[14, 14], [280, 280], [0.7, 0.73],
				[15, 15], [388, 390], [1.8, 1.84],
			],
			incorrect: [
				null, null, null,
				null, null, null,
				null, null, null,
			],
		};
	},
	mounted() {
		if (this.$tracker.isEasy()) {
			this.$set(this.answer, 5, this.correct[5]);
			this.$set(this.answer, 6, this.correct[6]);
		}
	}
};
</script>



<style scoped src="./numberTable.css"></style>
